import { render } from "./VideoPlaceholder.vue?vue&type=template&id=1f906f09"
import script from "./VideoPlaceholder.vue?vue&type=script&lang=js"
export * from "./VideoPlaceholder.vue?vue&type=script&lang=js"

import "./VideoPlaceholder.vue?vue&type=style&index=0&id=1f906f09&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__